<template>
  <div class="register-container">
    <div class="register-form">
      <div class="title">用户注册</div>
    <div class="center">
      <el-form
        ref="formInstance"
        :model="form"
        label-width="auto"
        status-icon
        style="max-width: 600px"
        :rules="rules"
      >
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="输入用户名(4-10位数字或字母组成)"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            show-password
            placeholder="输入登录密码(必须等于6位)"
          />
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item
          prop="code"
          :rules="[
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ]"
        >
          <div style="width: 50%">
            <el-input type="text" placeholder="验证码" v-model="form.code" />
            <i class="countdown"></i>
          </div>
          <div class="btnCode">
            <el-button type="primary" @click="getCodeFun">获取验证码</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="SubmitForm(formInstance)"
            >注册</el-button
          >
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <span>——————————————————————</span> -->
    <span class="toLogin" @click="toLogin">已有账号？立即登录 →</span>
  </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import type { FormInstance, FormRules } from "element-plus";
import { getCodeApi, registerApi } from "@/api/admin";
import { ElMessage } from "element-plus";

const router = useRouter();
const formInstance = ref<FormInstance>();

const form = reactive({
  username: "",
  password: "",
  phone: "",
  code: "",
});

const checkPhone = (rule: any, value: any, callback: any) => {
  if (!/^1[345789]\d{9}$/.test(value)) {
    console.log("手机号码格式不正确");
    return callback(new Error("手机号码格式不正确"));
  }
  return callback();
};

const rules = reactive<FormRules<typeof form>>({
  username: [
    { required: true, message: "请输入用户名", trigger: "blur" },
    {
      max: 10,
      min: 4,
      message: "用户名由4-10位数字或字母组成",
      trigger: "blur",
    },
  ],
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    { max: 6, min: 6, message: "密码必须等于6位数", trigger: "blur" },
  ],
  phone: [
    { required: true, message: "请输入手机号码", trigger: "blur" },
    { validator: checkPhone, trigger: "blur" },
  ],
});

const SubmitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    console.log(valid);
    if (valid) {
      // 请求
      registerApi(form).then((res) => {
        console.log(res);
        if (res.success) {
          // 跳转
          router.push("/login");

          // 提示
          ElMessage({
            message: "注册成功，请登录",
            type: "success",
          });
        }
      });
    }
  });
};

const getCodeFun = () => {
  if (/^1[345789]\d{9}$/.test(form.phone)) {
    getCodeApi(form.phone);
  }
};

const toLogin = () => {
  router.push("/login");
};
</script>
<style lang="less" scoped>
.register-container {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      to right,
      rgba(255,255,255,0.1) 20%,
      rgba(255,255,255,0) 100%
    );
    transform: rotate(30deg);
    animation: shine 3s infinite;
  }
}

@keyframes gradientBG {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes shine {
  0% { left: -50%; }
  100% { left: 150%; }
}

.register-form {
  width: 480px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1;
  animation: formEntrance 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  
  .el-form-item {
    margin-bottom: 28px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.title {
  text-align: center;
  font-size: 24px;
  color: #2c3e50;
  margin-bottom: 40px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #409EFF;
    border-radius: 2px;
  }
}

:deep(.el-input__inner) {
  height: 48px;
  padding-left: 40px !important;
  border-radius: 8px;
  transition: all 0.3s;
  
  &:hover {
    border-color: #409EFF;
  }
  
  &:focus {
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

.submit-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
  }
}

.toLogin {
  display: block;
  margin-top: 20px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s;
  
  &:hover {
    color: #409EFF;
    transform: translateX(5px);
  }
}

@keyframes formEntrance {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.verification-code {
  display: flex;
  gap: 12px;
  
  .send-btn {
    flex-shrink: 0;
    transition: all 0.3s;
    
    &.counting {
      background: #f5f7fa;
      color: #909399;
      cursor: not-allowed;
    }
  }
}
</style>
<!-- <style lang="less" scoped>
.register {
  width: 400px;
  margin: 100px auto;
  padding: 20px;
  text-align: center;
  border: 1px solid #ffffff99;
  .center {
    width: 300px;
    margin: 20px auto 0;
  }
  span {
    color: #ffffff99;
    display: inline-block;
  }
  .toLogin {
    font-size: 12px;
    cursor: pointer;
    color: #409eff;
  }
  .btnCode {
    width: 35%;
    margin-left: auto;
  }
}
</style> -->